export const toggleEllipsisExpandableTextOnClick = (e: Event) => {
  const element = e.target as HTMLElement;

  if (element) {
    const toggledClass = 'inner_cell_text';

    // ! If the user is doing a selection, the expansion/contraction status should not change
    // -- to be considered a selection we expect to have at least 3 characters selected. Otherwise we consider It is a mistake
    const isSelecting = window.getSelection().toString().length > 2;
    if (!isSelecting) element.classList.toggle(toggledClass);
  }
};
